import { PaymentDetails, PaymentStatus } from '../Payment';
import { ContestTaskType } from './ContestTask';
import { Locale } from '../Locale';
import { SchoolGrade } from '../location/School';
import { TeacherBaseDto } from '../auth/User';

export type AvailableContestTasks = Record<SchoolGrade | string, Record<ContestTaskType | string, Record<Locale | string, string>>>;

export class Contest {

  public id!: string;

  public name!: string;

  public description?: string;

  public instructions?: string;

  public price?: number;

  public paymentRequired?: boolean;

  public config?: ContestConfig;

  public startsAt?: Date | null;

  public endsAt?: Date | null;

  public enrolStartsAt?: Date | null;

  public enrolEndsAt?: Date | null;

  public createdAt?: Date | null;

  public modifiedAt?: Date | null;

  public paymentStatus?: PaymentStatus;

  public paymentAt?: Date | null;

  public teacher_id?: string;
  public teacher_first_name?: string;
  public teacher_last_name?: string;

  public tasks?: AvailableContestTasks;

  public taskInfoUrl?: string;

  public static parse(dto: ContestDto): Contest {
    const contest = new Contest();

    contest.id = dto.id || '';
    contest.name = dto.name;
    contest.description = dto.description;
    contest.instructions = dto.instructions;
    contest.price = dto.price;
    contest.paymentRequired = dto.payment_required != undefined ? dto.payment_required : true;
    contest.startsAt = dto.starts_at ? new Date(dto.starts_at) : null;
    contest.endsAt = dto.ends_at ? new Date(dto.ends_at) : null;
    contest.enrolStartsAt = dto.enrol_starts_at ? new Date(dto.enrol_starts_at) : null;
    contest.enrolEndsAt = dto.enrol_ends_at ? new Date(dto.enrol_ends_at) : null;
    contest.createdAt = dto.created_at ? new Date(dto.created_at) : null;
    contest.modifiedAt = dto.modified_at ? new Date(dto.modified_at) : null;
    contest.paymentStatus = dto.payment_status;
    contest.paymentAt = dto.payment_at ? new Date(dto.payment_at) : null;
    contest.tasks = dto.tasks;
    contest.taskInfoUrl = dto.task_info_url;

    if (dto.teacher_id) contest.teacher_id = dto.teacher_id;
    if (dto.teacher_first_name) contest.teacher_first_name = dto.teacher_first_name;
    if (dto.teacher_last_name) contest.teacher_last_name = dto.teacher_last_name;

    if (dto.config) contest.config = ContestConfig.parse(dto.config);

    return contest;
  }
}

export class ContestConfig {
  public static readonly DEFAULT_EXCELLENT_RATIO = 0.13;
  public static readonly DEFAULT_GOOD_RATIO = 0.38;
  public static readonly DEFAULT_AVERAGE_RATIO = 0.5;

  public duration?: number;
  public initialPointsBalance?: number;
  public answerPenalty?: number;
  public excellentRatio?: number;
  public goodRatio?: number;
  public averageRatio?: number;

  public static parse(dto: ContestConfigDto): ContestConfig {
    const config = new ContestConfig();

    config.duration = dto.duration;
    config.initialPointsBalance = dto.initial_points_balance;
    config.answerPenalty = dto.answer_penalty;
    config.excellentRatio = dto.excellent_ratio;
    config.goodRatio = dto.good_ratio;
    config.averageRatio = dto.average_ratio;

    return config;
  }
}

export interface ContestDto extends PaymentDetails, TeacherBaseDto {
  id?: string;

  name: string;

  description?: string;

  instructions?: string;

  price?: number;

  payment_required?: boolean;

  config: ContestConfigDto;

  created_at?: number;

  modified_at?: number;

  starts_at?: number;

  ends_at?: number;

  enrol_starts_at?: number;

  enrol_ends_at?: number;

  tasks?: AvailableContestTasks;

  task_info_url?: string;

}

export interface ContestConfigDto {
  duration: number;
  initial_points_balance: number;
  answer_penalty: number;
  excellent_ratio: number;
  good_ratio: number;
  average_ratio: number;
}
